// Multiplo de venta: `product.minimum` (0 o vacio = se vende de unidad en
// unidad). Los articulos que se sirven por caja, rollo o metro solo pueden
// pedirse en multiplos suyos, asi que TODA cantidad escrita a mano se redondea
// hacia ARRIBA al multiplo mas cercano (multiplo 4, escribe 10 => 12):
// redondear hacia abajo dejaria al cliente menos material del que ha pedido.
// Los botones + / - ya se movian de multiplo en multiplo, pero el input no
// validaba nada y la cantidad cruda llegaba al carrito.
//
// El multiplo puede ser decimal (2,5 m), asi que las divisiones se limpian del
// ruido del coma flotante antes de redondear.

// Tope del input de unidades de la ficha (atributo max de los <input>).
export const MAX_QUANTITY = 10000;

const EPSILON = 1e-9;

function clean(value) {
  return Math.round(value * 1e6) / 1e6;
}

function toStep(step) {
  const value = parseFloat(step);

  return value > 0 ? value : 1;
}

// Multiplo de venta de un producto, siempre > 0.
export function saleStep(product) {
  return toStep(product ? product.minimum : null);
}

export function roundUpToStep(value, step) {
  const safeStep = toStep(step);

  return clean(Math.ceil(clean(value / safeStep) - EPSILON) * safeStep);
}

export function roundDownToStep(value, step) {
  const safeStep = toStep(step);

  return clean(Math.floor(clean(value / safeStep) + EPSILON) * safeStep);
}

// Cantidad valida mas cercana por arriba: multiplo de `step`, nunca por debajo
// del propio multiplo ni por encima de `max` (que se baja al ultimo multiplo
// que cabe).
export function normalizeQuantity(value, step, max = MAX_QUANTITY) {
  const safeStep = toStep(step);
  const quantity = parseFloat(value);

  if (!isFinite(quantity) || quantity <= 0) return safeStep;

  const wanted = roundUpToStep(quantity, safeStep);
  if (wanted <= safeStep) return safeStep;

  const cap = roundDownToStep(max, safeStep);

  return wanted > cap ? Math.max(cap, safeStep) : wanted;
}

// Siguiente multiplo por encima de la cantidad actual (boton +).
export function nextQuantity(value, step, max = MAX_QUANTITY) {
  const safeStep = toStep(step);
  const current = parseFloat(value);
  const normalized = normalizeQuantity(current, safeStep, max);

  if (!isFinite(current) || normalized > current) return normalized;

  return normalizeQuantity(clean(normalized + safeStep), safeStep, max);
}

// Multiplo anterior (boton -), sin bajar nunca del multiplo de venta.
export function previousQuantity(value, step) {
  const safeStep = toStep(step);
  const current = parseFloat(value);

  if (!isFinite(current) || current <= safeStep) return safeStep;

  const down = roundDownToStep(current, safeStep);

  return Math.max(down < current ? down : clean(down - safeStep), safeStep);
}
